/*
  Unfazed gallery lightbox
  - Click any gallery photo to view it fullscreen using its data-full-src.
  - Close via the X button, a click anywhere on the overlay/image, or Esc.
  - Event delegation on document, so it works regardless of load timing.
*/
(function () {
  function getWrap(el) {
    return el.closest ? el.closest('.unfazed-gallery-wrap') : null;
  }

  function openLightbox(wrap, src, alt) {
    var lightbox = wrap.querySelector('[data-lightbox]');
    if (!lightbox) return;

    var img = lightbox.querySelector('[data-lightbox-img]');
    if (img) {
      img.setAttribute('src', src);
      img.setAttribute('alt', alt || '');
    }

    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Next frame so the opacity transition actually runs.
    requestAnimationFrame(function () {
      lightbox.classList.add('is-open');
    });
  }

  function closeLightbox(lightbox) {
    if (!lightbox || lightbox.hidden) return;

    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    var done = function () {
      lightbox.hidden = true;
      lightbox.removeEventListener('transitionend', done);
    };
    lightbox.addEventListener('transitionend', done);

    // Fallback in case transitionend does not fire.
    setTimeout(function () {
      if (!lightbox.classList.contains('is-open')) {
        lightbox.hidden = true;
      }
    }, 300);
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    // Open: click on a gallery image.
    var img = event.target.closest('.unfazed-gallery__img');
    if (img) {
      var wrap = getWrap(img);
      if (wrap) {
        var src = img.getAttribute('data-full-src') || img.currentSrc || img.src;
        openLightbox(wrap, src, img.getAttribute('alt'));
        return;
      }
    }

    // Close: click anywhere inside the lightbox (overlay, image, or close button).
    var lightbox = event.target.closest('[data-lightbox]');
    if (lightbox) {
      closeLightbox(lightbox);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      var open = document.querySelector('[data-lightbox].is-open');
      if (open) closeLightbox(open);
    }
  });
})();